// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background: #ffffff;
  border: 1px solid #f8f8f8;
  border-radius: 0 16px 16px 0;
  /*padding: 0 25px 25px;*/
  padding: 0px 0px 25px 0px;
  min-width: 300px;
  width: 300px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  /*overflow-y: auto;*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.sidebar .inner{
  overflow: auto;
  padding: 0 20px;
  min-height: 50px;
}

.isPersonalize{
  position: fixed;
  bottom: 0;
}
.mini-sidebar .inner{
  padding: 0;
}

.sidebar .split-sidebar {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  right: -10px;
  top: 25px;
  border: 0;
  background-color: #fff;
  box-shadow: 0 0 10px lightgrey;
  outline: none;
  z-index: 999;
  transition: transform .3s ease-in-out;
  transform: rotate(180deg);
}

.mini-sidebar.sidebar .split-sidebar {
  /*right: 33%;*/
  right: -15px;
  transform: rotate(0deg);
}

.mini-sidebar.sidebar {
  width: 80px !important;
  min-width: auto;
  padding: 10px 10px;
}

.mini-sidebar.sidebar .logo {
  display: none;
}

.sidebar .mini-logo {
  display: none;
}

.mini-sidebar.sidebar .mini-logo {
  display: block;
}

.mini-sidebar.sidebar li span {
  display: none !important;
}

.sidebar .close-btn {
  display: none;
}

.sidebar .img-title {
  min-height: 56px;
  margin: 20px 0 30px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  /*background: #f8fafb;*/
  border-radius: 11px;
  padding: 10px;
}

/*.sidebar .img-title .profile {
  border-radius: 4px;
  width: 32px;
  height: 32px;
}*/
.sidebar .img-title a {
  text-decoration: none;
}

.sidebar .img-title .profile {
  border-radius: 4px;
  width: 36px;
  height: 36px;
}

.profile-image {
  width: 36px;
  height: 36px;
  text-align: center;
  color: #ffffff;
  background: #bd50d0;
  border-radius: 4px;
  /*display: inline-block;*/
  font-size: 15px;
  font-weight: 600;
  vertical-align: middle;
  text-transform: uppercase;
  text-decoration: none;
  /*line-height: 1;*/
}

.sidebar .img-title p {
  font-weight: 500;
  font-size: 16px;
  color: #0f062b;
  margin-bottom: 0;
}

.mini-sidebar.sidebar .img-title p {
  display: none;
}

.sidebar nav ul {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}

.sidebar nav ul li {
  margin: 4px 0;
}

.sidebar nav ul li a {
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none;
  padding: 8px;
  border-radius: 8px;
  transition: 0.5s;
}

.mini-sidebar.sidebar nav ul li a {
  justify-content: center;
}

.sidebar nav ul li a:hover,
.sidebar nav ul li a.active {
  background: rgba(122, 45, 249, 0.1);
}

.sidebar nav ul li a:hover svg,
.sidebar nav ul li a.active svg {
  fill: #6c2fbb;
}

.sidebar nav ul li a:hover span,
.sidebar nav ul li a.active span {
  color: #6c2fbb;
}

.sidebar nav ul li a svg {
  fill: #595469;
  width: 20px;
  height: 20px;
  transition: 0.5s;
}
.sidebar nav ul li a svg.ai-icon {
  width: 24px;
  height: 24px;
}

.sidebar nav ul li a span {
  /*font-weight: 500;*/
  font-weight: 400;
  /*font-size: 17px; */
  font-size: 16px;
  color: #878395;
  transition: 0.5s;
}

.sidebar .logout a span{
  font-weight: 500 !important;
}
/*  display: flex;*/
/*  align-items: center;*/
/*  gap: 10px;*/
/*  padding: 8px;*/
/*  background-color: transparent;*/
/*  border-radius: 8px;*/
/*  width: 100%;*/
/*  border: none;*/
/*  outline: none;*/
/*  transition: 0.5s;*/
/*}*/

.mini-sidebar.sidebar nav ul .li-btn {
  display: none !important;
}

.sidebar nav ul .li-btn {
  gap: 10px;
  display: none;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  margin-top: 10px;
  /*margin: 15px auto 0;*/
}

.sidebar nav ul .li-btn a {
  width: 55px;
  height: 55px;
  padding: 0;
}

.sidebar nav ul .li-btn.active {
  display: block;
}

.sidebar nav ul .li-btn a .img-btn {
  max-width: 90px;
}

.sidebar nav ul .li-btn {
  width: -moz-fit-content;
  width: fit-content;
}

.sidebar nav ul .li-btn:hover a {
  background-color: transparent;
}

.sidebar nav ul .li-btn.active a {
  background-color: transparent;
}

/*.sidebar .logout button.active,*/
/*.sidebar .logout button:hover {*/
/*  background: rgba(122, 45, 249, 0.1);*/
/*}*/

/*.sidebar .logout button.active span,*/
/*.sidebar .logout button:hover span {*/
/*  color: #6c2fbb;*/
/*}*/

/*.sidebar .logout button.active svg,*/
/*.sidebar .logout button:hover svg {*/
/*  fill: #6c2fbb;*/
/*}*/

/*.sidebar .logout button span {*/
/*  padding-top: 2px;*/
/*  font-weight: 500;*/
/*  font-size: 17px;*/
/*  color: #878395;*/
/*  transition: 0.5s;*/
/*}*/

.sidebar .logout a svg {
  fill: #6c2fbb !important;
}

@media (max-width: 991px) {
  .sidebar {
    left: -300px;
    transition: left 0.5s;
  }

  .sidebar.active {
    left: 0;
  }

  .sidebar .close-btn {
    display: block;
    border: none;
    background-color: transparent;
    outline: none;
    position: absolute;
    right: 15px;
    top: 10px;
    min-width: 30px;
    height: 30px;
  }

  .sidebar .split-sidebar{
    display: none;
  }
}

@media (max-width: 425px) {
  .sidebar nav ul li a span {
    font-size: 16px;
  }
}

@media (max-width: 320px) {
  .sidebar {
    padding: 15px;
    min-width: 280px;
    left: -300px;
  }
}

.img-fluid.logo {
  padding-left: 10px;
}

object svg {
  fill: red;
}

.upgrade-li a {
  color: #6c2fbb;
  border: 1px solid #6c2fbb;
  margin-bottom: 2rem;
  margin-top: -1rem;
}

.upgrade-li a span {
  color: #6c2fbb !important;
}

.New {
  background: rgb(194, 38, 38);
  border-radius: 20px;
  border: none;
  outline: none;
  color: #fff;
  padding: 5px 12px;
  margin-left: -5px;
  font-weight: bold;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;;EAIE;AACF;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA,mBAAmB;AACnB,yBAAyB;AACzB,eAAe;AACf,kBAAkB;AAClB,mCAAmC;AACnC,wBAAwB;AACxB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB,sBAAsB;AACtB,IAAI;;AAEJ;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,yCAAyC;AACzC,IAAI;;AAEJ,uCAAuC;AACvC,uCAAuC;AACvC,oBAAoB;AACpB,IAAI;;AAEJ,sCAAsC;AACtC,sCAAsC;AACtC,mBAAmB;AACnB,IAAI;;AAEJ,iCAAiC;AACjC,sBAAsB;AACtB,sBAAsB;AACtB,qBAAqB;AACrB,oBAAoB;AACpB,sBAAsB;AACtB,IAAI;;AAEJ;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".sidebar {\n  background: #ffffff;\n  border: 1px solid #f8f8f8;\n  border-radius: 0 16px 16px 0;\n  /*padding: 0 25px 25px;*/\n  padding: 0px 0px 25px 0px;\n  min-width: 300px;\n  width: 300px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  height: 100%;\n  /*overflow-y: auto;*/\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 99;\n}\n\n.sidebar .inner{\n  overflow: auto;\n  padding: 0 20px;\n  min-height: 50px;\n}\n\n.isPersonalize{\n  position: fixed;\n  bottom: 0;\n}\n.mini-sidebar .inner{\n  padding: 0;\n}\n\n.sidebar .split-sidebar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  right: -10px;\n  top: 25px;\n  border: 0;\n  background-color: #fff;\n  box-shadow: 0 0 10px lightgrey;\n  outline: none;\n  z-index: 999;\n  transition: transform .3s ease-in-out;\n  transform: rotate(180deg);\n}\n\n.mini-sidebar.sidebar .split-sidebar {\n  /*right: 33%;*/\n  right: -15px;\n  transform: rotate(0deg);\n}\n\n.mini-sidebar.sidebar {\n  width: 80px !important;\n  min-width: auto;\n  padding: 10px 10px;\n}\n\n.mini-sidebar.sidebar .logo {\n  display: none;\n}\n\n.sidebar .mini-logo {\n  display: none;\n}\n\n.mini-sidebar.sidebar .mini-logo {\n  display: block;\n}\n\n.mini-sidebar.sidebar li span {\n  display: none !important;\n}\n\n.sidebar .close-btn {\n  display: none;\n}\n\n.sidebar .img-title {\n  min-height: 56px;\n  margin: 20px 0 30px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /*background: #f8fafb;*/\n  border-radius: 11px;\n  padding: 10px;\n}\n\n/*.sidebar .img-title .profile {\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n}*/\n.sidebar .img-title a {\n  text-decoration: none;\n}\n\n.sidebar .img-title .profile {\n  border-radius: 4px;\n  width: 36px;\n  height: 36px;\n}\n\n.profile-image {\n  width: 36px;\n  height: 36px;\n  text-align: center;\n  color: #ffffff;\n  background: #bd50d0;\n  border-radius: 4px;\n  /*display: inline-block;*/\n  font-size: 15px;\n  font-weight: 600;\n  vertical-align: middle;\n  text-transform: uppercase;\n  text-decoration: none;\n  /*line-height: 1;*/\n}\n\n.sidebar .img-title p {\n  font-weight: 500;\n  font-size: 16px;\n  color: #0f062b;\n  margin-bottom: 0;\n}\n\n.mini-sidebar.sidebar .img-title p {\n  display: none;\n}\n\n.sidebar nav ul {\n  padding-left: 0;\n  list-style: none;\n  margin-bottom: 0;\n}\n\n.sidebar nav ul li {\n  margin: 4px 0;\n}\n\n.sidebar nav ul li a {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  text-decoration: none;\n  padding: 8px;\n  border-radius: 8px;\n  transition: 0.5s;\n}\n\n.mini-sidebar.sidebar nav ul li a {\n  justify-content: center;\n}\n\n.sidebar nav ul li a:hover,\n.sidebar nav ul li a.active {\n  background: rgba(122, 45, 249, 0.1);\n}\n\n.sidebar nav ul li a:hover svg,\n.sidebar nav ul li a.active svg {\n  fill: #6c2fbb;\n}\n\n.sidebar nav ul li a:hover span,\n.sidebar nav ul li a.active span {\n  color: #6c2fbb;\n}\n\n.sidebar nav ul li a svg {\n  fill: #595469;\n  width: 20px;\n  height: 20px;\n  transition: 0.5s;\n}\n.sidebar nav ul li a svg.ai-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.sidebar nav ul li a span {\n  /*font-weight: 500;*/\n  font-weight: 400;\n  /*font-size: 17px; */\n  font-size: 16px;\n  color: #878395;\n  transition: 0.5s;\n}\n\n.sidebar .logout a span{\n  font-weight: 500 !important;\n}\n/*  display: flex;*/\n/*  align-items: center;*/\n/*  gap: 10px;*/\n/*  padding: 8px;*/\n/*  background-color: transparent;*/\n/*  border-radius: 8px;*/\n/*  width: 100%;*/\n/*  border: none;*/\n/*  outline: none;*/\n/*  transition: 0.5s;*/\n/*}*/\n\n.mini-sidebar.sidebar nav ul .li-btn {\n  display: none !important;\n}\n\n.sidebar nav ul .li-btn {\n  gap: 10px;\n  display: none;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0;\n  margin-top: 10px;\n  /*margin: 15px auto 0;*/\n}\n\n.sidebar nav ul .li-btn a {\n  width: 55px;\n  height: 55px;\n  padding: 0;\n}\n\n.sidebar nav ul .li-btn.active {\n  display: block;\n}\n\n.sidebar nav ul .li-btn a .img-btn {\n  max-width: 90px;\n}\n\n.sidebar nav ul .li-btn {\n  width: fit-content;\n}\n\n.sidebar nav ul .li-btn:hover a {\n  background-color: transparent;\n}\n\n.sidebar nav ul .li-btn.active a {\n  background-color: transparent;\n}\n\n/*.sidebar .logout button.active,*/\n/*.sidebar .logout button:hover {*/\n/*  background: rgba(122, 45, 249, 0.1);*/\n/*}*/\n\n/*.sidebar .logout button.active span,*/\n/*.sidebar .logout button:hover span {*/\n/*  color: #6c2fbb;*/\n/*}*/\n\n/*.sidebar .logout button.active svg,*/\n/*.sidebar .logout button:hover svg {*/\n/*  fill: #6c2fbb;*/\n/*}*/\n\n/*.sidebar .logout button span {*/\n/*  padding-top: 2px;*/\n/*  font-weight: 500;*/\n/*  font-size: 17px;*/\n/*  color: #878395;*/\n/*  transition: 0.5s;*/\n/*}*/\n\n.sidebar .logout a svg {\n  fill: #6c2fbb !important;\n}\n\n@media (max-width: 991px) {\n  .sidebar {\n    left: -300px;\n    transition: left 0.5s;\n  }\n\n  .sidebar.active {\n    left: 0;\n  }\n\n  .sidebar .close-btn {\n    display: block;\n    border: none;\n    background-color: transparent;\n    outline: none;\n    position: absolute;\n    right: 15px;\n    top: 10px;\n    min-width: 30px;\n    height: 30px;\n  }\n\n  .sidebar .split-sidebar{\n    display: none;\n  }\n}\n\n@media (max-width: 425px) {\n  .sidebar nav ul li a span {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 320px) {\n  .sidebar {\n    padding: 15px;\n    min-width: 280px;\n    left: -300px;\n  }\n}\n\n.img-fluid.logo {\n  padding-left: 10px;\n}\n\nobject svg {\n  fill: red;\n}\n\n.upgrade-li a {\n  color: #6c2fbb;\n  border: 1px solid #6c2fbb;\n  margin-bottom: 2rem;\n  margin-top: -1rem;\n}\n\n.upgrade-li a span {\n  color: #6c2fbb !important;\n}\n\n.New {\n  background: rgb(194, 38, 38);\n  border-radius: 20px;\n  border: none;\n  outline: none;\n  color: #fff;\n  padding: 5px 12px;\n  margin-left: -5px;\n  font-weight: bold;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
